import { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Forms from 'contexts/Forms'
import { IGetMatchedProductSummaryResponse, IProduct } from 'interfaces/mortgageResult.interface'

const useMortgageResult = () => {
  const { mortgageResultLoading } = useContext(Forms)
  const [loading, setLoading] = useState(mortgageResultLoading)
  const [error] = useState(false)
  const navigate = useNavigate()
  const mortgageResult: IGetMatchedProductSummaryResponse = JSON.parse(localStorage.getItem('mortgageResult') || '{}')

  useEffect(() => {
    setLoading(mortgageResultLoading)
  }, [mortgageResultLoading])

  const onRowClick = useCallback((rowProps: any) => {
    const productId = rowProps.data.productId
    const correlationId = rowProps.data.correlationId
    navigate(`/mortgage-details?productId=${productId}&correlationId=${correlationId}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filteredData = mortgageResult.GetMatchedProductSummaryResponse.Data.Products.Products.map((product: IProduct) => ({
    ...product.CalcFields,
    key: product.CalcFields.ProductId,
    productId: product.CalcFields.ProductId,
    correlationId: mortgageResult.GetMatchedProductSummaryResponse.Header.CorrelationID._,
  }))

  return {
    onRowClick,
    error,
    loading,
    filteredData,
  }
}

export default useMortgageResult
